import { create } from 'zustand';
import {
  ValueType,
  RequestData,
  InternalAnswerSet,
  InternalTableAnswerSet,
  ContactAnswer,
} from '@components/dynamic-form/types';
import _cloneDeep from 'lodash/cloneDeep';
import { resolveRequestConfig } from '@src/utils/helpers';

interface FormStoreValues {
  defaultValues: { [key: string]: ValueType | undefined }; // NOTE: react-hook-form answers
  requestData: RequestData;
  fullQuestionIds: number[];
  questionVisibility: { [questionId: number]: boolean };
  answerSet: InternalAnswerSet; // NOTE: coming from API response
  tableAnswerSet: InternalTableAnswerSet;
  contactAnswerSet: ContactAnswer[];
  isSubmit: boolean;
}

interface FormState extends FormStoreValues {
  clearAnswers: (formId: number) => void;
  resetToDefaults: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setApiAnswers: (data: any) => void;
  setFullQuestionIds: (fullQuestionIds: number[]) => void;
  setQuestionVisibility: (questionId: number, isVisible: boolean) => void;
  setIsSubmit: (isSubmit: boolean) => void;
}

const defaults: FormStoreValues = {
  answerSet: {},
  contactAnswerSet: [],
  defaultValues: {},
  fullQuestionIds: [],
  questionVisibility: {},
  requestData: {},
  tableAnswerSet: {},
  isSubmit: false,
};

export const useFormStore = create<FormState>((set) => ({
  ..._cloneDeep(defaults),

  clearAnswers: () => {},

  resetToDefaults: () => set(_cloneDeep(defaults)),

  setFullQuestionIds: (fullQuestionIds) => set({ fullQuestionIds }),

  setQuestionVisibility: (questionId, isVisible) => {
    set((state) => ({
      questionVisibility: {
        ...state.questionVisibility,
        [questionId]: isVisible,
      },
    }));
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setApiAnswers: (data: any) => {
    const requestType = data?.request?.requestType;
    const formVersion = data?.request?.formVersion;

    set(resolveRequestConfig(data, requestType, formVersion));
  },

  setIsSubmit: (isSubmit: boolean) => set({ isSubmit }),
}));
